import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Uuid } from '../models/uuid';

export interface BackgroundJob {
  id: Uuid;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class BackgroundJobsService {
  private readonly _jobs$ = new BehaviorSubject<BackgroundJob[]>([]);

  readonly jobs$: Observable<BackgroundJob[]> = this._jobs$.asObservable();

  add(id: Uuid, description: string): void {
    const current = this._jobs$.getValue();
    if (current.some((job) => job.id === id)) {
      return;
    }
    this._jobs$.next([...current, { id, description }]);
  }

  remove(id: Uuid): void {
    const current = this._jobs$.getValue();
    this._jobs$.next(current.filter((job) => job.id !== id));
  }

  hasJob(id: Uuid): boolean {
    return this._jobs$.getValue().some((job) => job.id === id);
  }

  readonly hasJobs$: Observable<boolean> = this._jobs$.pipe(map((jobs) => jobs.length > 0));
}
